import { render, staticRenderFns } from "./modify-dialog.vue?vue&type=template&id=abbb4fb2&scoped=true"
import script from "./modify-dialog.vue?vue&type=script&lang=js"
export * from "./modify-dialog.vue?vue&type=script&lang=js"
import style0 from "./modify-dialog.vue?vue&type=style&index=0&id=abbb4fb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abbb4fb2",
  null
  
)

export default component.exports